<template>
  <Modal class="createPick" width="800" v-model="createPickListModel" @on-visible-change='createPickListChange' :title="$t('key1004785')">
    <div class="list">
      <div v-if="defaultShow">
        <h5 class="pt10 pb10">{{ $t('key1004786') }}</h5>
        <pickingRules
          :allowDiffWarehouseBlockGroup="false"
          :pickingSetInfo="pickingSetInfo"
          @updateRulesData="updateRulesData">
        </pickingRules>
      </div>
      <div v-else>
        <successCrtPickList :createAfterTableData="createAfterTableData"></successCrtPickList>
      </div>
    </div>
    <template #footer>
      <div v-if="defaultShow">
        <Button @click="close">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="clickBtn" :disabled="disabledCreateBtn">{{ $t('key1004785') }}</Button>
      </div>
      <div v-else>
        <Button @click="close">{{ $t('key1000248') }}</Button>
        <Button type="primary" @click="toPickList">{{ $t('key1004787') }}</Button>
      </div>
    </template>
  </Modal>
</template>
<style lang='less' scoped>
.tag_boxs {
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  color: #333;
  border: 1px solid #ccc;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 10px 10px 0;
}
</style>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import pickingRules from "@/components/common/pickingRules";
import successCrtPickList from "@/views/yms/components/wms/exWarehouse/successCrtPickList.vue";
import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllYmsWarehouseData} from "@/utils/common";

export default {
  mixins: [Mixin],
  props: {
    parameterObj: {
      type: Object,
      default: () => {
      }
    },
    isNeedAssemble: { // 是否是组装：1 是  0否
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultShow: true,
      createAfterTableData: [],
      stockOutType: [
        {code: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000203'), value: 'SS'},
        {code: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000202'), value: 'MM'}
      ],
      disabledCreateBtn: false,
      createPickListModel: false,
      selectTableData: [],
      createType: null,
      clickRowObj: {},
      pickingRule: {},
      pickingSetInfo: {}
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initCreatePickListData(selectTableData, createType, row) {
      let v = this;
      v.createType = createType;
      v.clickRowObj = row;
      v.selectTableData = selectTableData;
      // 获取缓存中拣货单规则设置
      let userId = v.userInfo.userId;
      let pickListSetting = localStorage.getItem('pickListSetting' + userId);
      if (pickListSetting) {
        v.pickingSetInfo = JSON.parse(pickListSetting);
      }
      v.createPickListModel = true;
    },
    // 生成拣货单
    clickBtn() {
      let v = this;
      let keyList = [
        'allowDiffLogisticsDealer',
        'allowDiffMailMode',
        'allowDiffWarehouseBlock',
        'regularOrderMax',
        'stockListMax'
      ];
      let {shippingMethodId, pageNum, pageSize, pickingExtendList, ...obj} = v.parameterObj;
      obj.isNeedAssemble = v.isNeedAssemble;
      // 勾选
      if (v.createType === 'select') {
        obj.packageCodes = v.selectTableData.map(val => {
          return val.packageCode;
        });
      }
      // 单个
      else if (v.createType === 'single') {
        obj.packageCodes = [v.clickRowObj.packageCode];
      }
      keyList.map((key) => {
        obj[key] = v.pickingRule[key];
      });
      obj.allowDiffMailMode = v.pickingRule.allowDiffLogisticsDealer === '1' ? null : v.pickingRule.allowDiffMailMode;
      if (v.system === 'yms') {
        if (!obj.stockListMax) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004783'));
          return false;
        }
      }
      if (!obj.regularOrderMax) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004784'));
        return false;
      }
      v.axios.post(api.post_ymsPickingOrder_create, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          localStorage.setItem('pickListSetting' + v.userInfo.userId, JSON.stringify(v.pickingRule));
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          let data = res.data.datas;
          v.$emit('closeSuccess', 'update');
          getAllYmsWarehouseData().then(warehouse => {
            data.forEach(i => {
              warehouse.forEach(j => {
                if (i.ymsWarehouseId === j.ymsWarehouseId) {
                  i.warehouseName = j.name;
                }
              });
            });
          });
          v.createAfterTableData = data;
          v.defaultShow = false;
        }
      });
    },
    toPickList() {
      if (this.$route.path === '/assembleGeneratePickingList') {
        this.$router.push('/assemblePickingList');
      } else {
        this.$router.push('/wms/pickList');
      }
    },
    // 关闭、取消生成拣货单弹窗
    close(value) {
      this.$emit('closeSuccess', value);
      this.createAfterTableData = [];
      this.createPickListModel = false;
      this.defaultShow = true;
    },
    // 监听弹窗
    createPickListChange(value) {
      let v = this;
      if (value) {
        v.defaultShow = true;
      }
    },
    // 获取拣货单生成规则数据
    updateRulesData(data) {
      this.pickingRule = data;
    }
  },
  components: {
    pickingRules,
    successCrtPickList
  }
};
</script>
